import { PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { METRIC_GAME_HEADER } from '@config'
import { createClient } from '@services'
import qs from 'qs'

const { get, uploadFile, del, put, post } = createClient()

/* API request to get files */
export function getAllFilesRequest(gameNameId, modNameId, query) {
  return requestAll(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files`,
    query
  )
}

/* API request to get sources */
export function getAllSourcesRequest(gameNameId, modNameId, query) {
  return requestAll(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/sources`,
    query
  )
}

/* API request to get cooks */
export function getAllCooksRequest(gameNameId, modNameId, query) {
  return requestAll(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/cooks`,
    query
  )
}

/* API request to fetch Cloud Cooking logs */
export async function getCloudCookingLogsRequest(gameNameId, uuid, platform) {
  const { data } = await get(
    `/games/@${gameNameId}/cloud-cooking/cook-log${queryString({ cook_uuid: uuid })}`,
    {
      headers: {
        'X-Modio-Platform': platform,
      },
    }
  )
  return data
}

/* API request to download a file */
export async function downloadFileRequest(fileUrl, onDownloadProgress) {
  const config = { responseType: 'blob' }
  if (onDownloadProgress) {
    config.onDownloadProgress = onDownloadProgress
  }
  const { data } = await get(fileUrl, config)
  return data
}

/* API request to add file */
export async function addFileRequest(
  type,
  gameNameId,
  modNameId,
  upload,
  onUploadProgress
) {
  const { data } = await uploadFile(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/${type}`,
    upload,
    onUploadProgress
  )
  return data
}

/* API request to start a multipart session */
export async function startMultipartUploadSessionRequest(
  gameNameId,
  modNameId,
  filename
) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/multipart`,
    qs.stringify({ filename })
  )
  return data
}

/* API request to add a part to a multipart session */
export function addMultipartUploadPartRequest(
  gameNameId,
  modNameId,
  uploadId,
  part,
  contentRange,
  onUploadProgress,
  abortSignal
) {
  return put(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/multipart?upload_id=${uploadId}`,
    part,
    {
      headers: {
        'Content-Range': contentRange,
        'Content-Type': 'multipart/form-data',
        [METRIC_GAME_HEADER]: GAME_ID,
      },
      onUploadProgress,
      signal: abortSignal,
    }
  )
}

/* API request to complete a multipart session */
export async function completeMultipartUploadSessionRequest(
  gameNameId,
  modNameId,
  upload_id
) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/multipart/complete`,
    qs.stringify({ upload_id })
  )
  return data
}

/* API request to update a file */
export async function updateFileRequest(gameNameId, modNameId, fileId, update) {
  const { data } = await put(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/${fileId}`,
    qs.stringify(update)
  )
  return data
}

/* API request to update a file's platform status */
export async function updateFilePlatformStatusRequest(
  gameNameId,
  modNameId,
  fileId,
  update
) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/${fileId}/platforms`,
    qs.stringify(update)
  )

  return data
}

/* API request to delete file */
export async function deleteFileRequest(gameNameId, modNameId, fileId) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/files/${fileId}`
  )
  return data
}
